import React from 'react'
import { useTranslation } from 'react-i18next'
import {observer} from 'mobx-react'
import {useInjection} from 'dna-react-ioc'
import {TransactionSummaryDoughnutChartCard} from '@/components/composite'
import {EcomTransactionSummaryDoughnutChartCardStoreType} from '@/pages/Reports/components'
import {TSelectContainerStore} from '@/components/containers'

export const PMStoreSymbol = Symbol('PMStoreSymbol')
export const PMStatusStoreSymbol = Symbol('PMStatusStore')

export const PMDoughnutChartContainer = observer(() => {
    const { t } = useTranslation()
    const store = useInjection<EcomTransactionSummaryDoughnutChartCardStoreType>(PMStoreSymbol)
    const selectStore = useInjection<TSelectContainerStore>(PMStatusStoreSymbol)

    return (
        <TransactionSummaryDoughnutChartCard
            tooltipText={t('Reports.paymentMethods')}
            amountData={store.amountData}
            countData={store.countData}
            tabType={store.chartType}
            setChartType={store.setChartTabType}
            title={t('Reports.paymentMethods')}
            centerTitle={t('Reports.volumeTotal')}
            selectStatusProps={{
                value: selectStore.value,
                options: selectStore.options,
                onChange: selectStore.setValue
            }}
            loadingState={store.amountLoadingState}
            currency={store.currency}
        />
    )
})
